import { QueryClient } from '@tanstack/react-query'

import { ApiError } from './api'

/**
 * React Query client.
 * - retry only on network errors (not on 4xx — those are deterministic)
 * - staleTime 30s: avoid hammering the dashboard on every tab focus
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Don't retry 4xx — they won't succeed by repeating
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false
        }
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
